import React from 'react'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'
import { eq } from 'lodash/lang'
import styles from './ClientLinkingModal.scss'
import NoResults from '../noResults'
import TooManyResults from '../tooManyResults'
import underscore from 'underscore'

import i18n from 'lib/i18n'
const _ = i18n('clients')

export default class ClientLinkingSearchResults extends React.Component {
	static propTypes = {
		data: React.PropTypes.array,
		selectClientMethod: React.PropTypes.func,
		selectedClientId: React.PropTypes.string
	}

	constructor(props) {
		super(props)
	}

	shouldComponentUpdate(nextProps) {
		return !eq(this.props.data, nextProps.data)
	}



	onClientSelectClick(clientId) {
		const { selectClientMethod } = this.props
		selectClientMethod(clientId)
	}

	render() {
		const { data, selectedClientId } = this.props

		return (
			<div className={styles.clientsTableContainer}>
				{data && underscore.isArray(data) && (data[0] !== 'Too many rows') &&
					<Table
						className={styles.table}
						itemsPerPage={20}
						filterable={[
							"name",
							"email",
							"clientNumber",
						]}
						sortable={[
							"name",
							"email",
							"clientNumber",
						]}
						defaultSort={{
							column: 'name',
							direction: 'desc',
						}}
					>
						<Thead>
							<Th column="checkBox">{' '}</Th>
							<Th column="clientNumber">
								<strong>{_('clientNumber')}</strong>
							</Th>
							<Th column="name">
								<strong>{_('name')}</strong>
							</Th>
							<Th column="email">
								<strong>{_('email')}</strong>
							</Th>
							<Th column="address">
								<strong>{_('clientAddress')}</strong>
							</Th>
						</Thead>
						{data.map((item, key) =>
							<Tr
								className="clickable centered"
								onClick={() => {
									if (!selectedClientId || selectedClientId === item.clientId) {
										this.onClientSelectClick(item.clientId)
									}
								}}
								key={key}
							>
								<Td column="checkBox" >
									<div style={{ width: 15 }}>
										<input
											type="checkbox"
											onClick={ev => ev.stopPropagation()}
											onChange={ev => this.onClientSelectClick(item.clientId)}
											checked={selectedClientId && selectedClientId === item.clientId ? true : false}
											disabled={selectedClientId && selectedClientId !== item.clientId}
										/>
									</div>
								</Td>
								<Td column="clientNumber">{item.clientNumber}</Td>
								<Td column="name">{item.name}</Td>
								<Td column="email">{item.email}</Td>
								<Td column="address">{item.mainAddress}</Td>
							</Tr>
						)
						}
					</Table>
				}
				{data && underscore.isArray(data) && data.length === 0 &&
					<NoResults type="clients" />
				}
				{data && underscore.isArray(data) && data[0] === 'Too many rows' &&
					<TooManyResults type="clients" />
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/inbox/ClientLinkingSearchResult.jsx